// Library
import React from 'react'

// CSS
import PageNotFoundImage from '../../assets/img/PageNotFound2.svg';

export default function PageNotFound() {
    return (
        <div>
            <div className="row mt-5">
                <div className="col-12">
                    <div className="text-center">
                        {/* <h1 className="text-muted">404</h1> */}
                        <img className="img-fluid" src={PageNotFoundImage} alt="Page Not Found..." width="250px" />
                        <h4 className="text-muted mt-2">Page not found!</h4>
                    </div>
                </div>
            </div>
        </div>
    )
}
